<template>
  <v-row style="margin: auto;" justify="center">
    <v-row style="padding-bottom: 50px; margin-left: 100px;">
      <span style="color: #0A7EA5; font-size: 16px; cursor: pointer;" @click="getBackList()" class="hover-back">
        &lt;Back
      </span>
    </v-row>
    <v-row style="margin-left: -100px;">
      <v-card-title>
        <v-container class="pa-12">
          <v-card class="pl-16 pr-16 pt-8 pb-16">
            <div fill-width class="pb-5" align="end">
              <!-- <v-btn
                  :disabled="sostatus"
                  class="mx-2"
                  fab
                  dark
                  color="#689ADE"
                  @click="saveSOdraftstatus()"
                >
                  <v-icon color="black">
                    mdi-close
                  </v-icon>
                </v-btn> -->
            </div>
            <v-card-title>
              <v-row>
                <v-col cols="6" md="6" justify="center">
                  <h3>Sales Order</h3>
                </v-col>
                <v-col cols="6" md="6">
                  <v-row>
                    <v-col class="text-right" cols="12" md="12">
                      <h5>No. {{ saleorder_id }}</h5>
                      <h5>Date {{ datecreate_at }}</h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-title>
            <v-row class="row1 mt-3  pt-3 ">
              <v-col cols="12" md="2">
                <v-autocomplete v-model="customer_code" :items="customer" item-text="cust_account"
                  item-value="cust_account" outlined @change="onSelectCustomerCodeChange(customer_code)"
                  :disabled="sostatus" dense label="Customer Code"></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete v-model="customer_name" :disabled="sostatus" :items="customer_list" item-text="name"
                  item-value="id" outlined @change="onSelectCustomerChange(customer_name)" dense
                  label="Client Name"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="10">
                <v-text-field v-model="customer_address" outlined dense label="Customer Address"
                  :disabled="sostatus"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="10">
                <v-text-field v-model="invoice_address" outlined dense label="Invoice Address"
                  background-color="#F5F5F5" disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="5">
                <v-text-field v-model="tax_id" outlined dense label="Tax ID " background-color="#F5F5F5"
                  disabled></v-text-field>
              </v-col>

              <v-col cols="12" sm="5">
                <v-text-field v-model="branch" outlined dense label="Branch" background-color="#F5F5F5"
                  disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="3">
                <v-text-field v-model="payment_term" outlined dense label="Payment Term (Day)"
                  :disabled="sostatus"></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-text-field v-model="currency" outlined dense label="Currency" :disabled="sostatus"></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-text-field v-model="vat" @keyup="calvatAll(vat)" outlined dense label="Vat (%)"
                  :disabled="sostatus"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-select required outlined :items="vat_type_list" v-model="vat_type" item-value="id" item-text="name"
                  label="Vat Type" dense disabled></v-select>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="5">
                <v-text-field v-model="os_h.remark" outlined dense :disabled="sostatus"
                  label="Attention"></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field v-model="os_h.contact_position" outlined dense :disabled="sostatus"
                  label="Contact Position"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
              <v-col cols="12" md="4">
                <v-text-field v-model="os_h.po_no" outlined :disabled="sostatus" dense label="PO NO."></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDatePOFormatted" :disabled="sostatus" label="PO Date"
                      append-icon="mdi-calendar" readonly dense outlined v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="os_h.po_date" @input="menu = false"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="4">
                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateDeliveryFormatted" label="Delivery date"
                      append-icon="mdi-calendar" :disabled="sostatus" readonly dense outlined v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="os_h.delivery_date" @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="7">
                <v-textarea v-model="os_h.additional" multi-line outlined dense :disabled="sostatus"
                  label="Additional information"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <input type="file" accept="image/.png.jpg" multiple="multiple" @change="previewMultiImage"
                  class="inputsize" ref="file" style="display: none" />
                <v-btn :disabled="sostatus" class="btnuploadfile" @click="$refs.file.click()" elevation="7">
                  <v-icon left dark> mdi-cloud-upload </v-icon>Upload
                  file</v-btn>
              </v-col>
            </v-row>
            <div class="border p-2 mt-3">
              <div v-if="this.filenameattach.length > 0">
                <span v-for="(item, index) in this.filenameattach" :key="index">
                  <a @click="previewattachfile(index)">{{ item }}</a>

                  <v-btn :disabled="sostatus" :style="{
                    backgroundColor: '#FFEBEE',
                    color: '#F44336',
                  }" small icon @click="confirmdeleteattachfile(index)">
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>

                  <br />
                </span>
              </div>

              <!-- <template v-if="preview_list.length">
                  <p>
                    Preview Currently Image:
                    <span class="red--text">(click image to remove image)</span>
                  </p>
                  <v-row>
                    <v-col
                      v-for="(item, index) in preview_list"
                      :key="index"
                      class="d-flex child-flex"
                      cols="3"
                    >
                      <v-img
                        :src="item"
                        class="grey lighten-2 mt-3 mb-5"
                        aspect-ratio="1"
                        contain
                        @click="clickremoveimage(index)"
                      >
                      </v-img>
                    </v-col>
                  </v-row>
                </template> -->
            </div>

            <div class="border p-2 mt-3">
              <template v-if="oldpreview_list.length">
                <p>
                  Preview Old Image:
                  <span class="red--text">(Preview Only)</span>
                </p>
                <v-row>
                  <v-col v-for="(item, index) in oldpreview_list" :key="index" class="d-flex child-flex" cols="3">
                    <v-img disabled :src="item" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
                    </v-img>
                    <!-- <p class="mb-0">file name: {{ image_list[index].name }}</p>
                        <p>size: {{ image_list[index].size / 1024 }}KB</p> -->
                  </v-col>
                </v-row>
              </template>
            </div>

            <br />

            <template>
              <template>
                <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1 "
                  hide-default-footer>
                  <!-- <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th v-for="h in headers" :class="h.class">
                            <span>{{ h.text }}</span>
                          </th>
                        </tr>
                      </thead>
                    </template> -->

                  <template v-slot:top>
                    <v-toolbar flat>
                      <!-- <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer> -->
                      <v-dialog v-model="dialog" max-width="500px">
                        <!-- <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              dark
                              class="mb-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              New Item
                            </v-btn>
                          </template> -->
                      </v-dialog>
                      <v-dialog v-model="dialogDelete" max-width="400px">
                        <v-card style="padding-top: 30px; padding-bottom: 30px;">
                          <v-card-title style="padding-bottom: 20px;">
                            <v-row justify="center">
                              <span class="red--text text-h5 ju">Delete this item?</span>
                            </v-row>
                          </v-card-title>
                          <br />
                          <v-card-subtitle>
                            <v-row justify="center">
                              <span class="black--text">This action cannot be undone.</span>
                            </v-row>
                          </v-card-subtitle>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn depressed width="100" class="mr-3 buttonblue" color="red" @click="deleteItemConfirm">
                              Save
                            </v-btn>
                            <v-btn depressed outlined width="100" color="red" @click="closeDelete">
                              Cancel
                            </v-btn>

                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>

                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">
                      Reset
                    </v-btn>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <!-- <v-icon small class="mr-2" @click="editItem(item)">
                        mdi-pencil
                      </v-icon> -->

                    <v-btn :disabled="sostatus" @click="deleteItem(item)" :style="{
                      backgroundColor: '#9E3B1B',
                      color: 'white',
                    }">
                      <v-icon small>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </template>

              <!-- <v-simple-table>
                  <tbody>
                    <tr>
                      <td width="10%"></td>
                      <td width="37%">
                        <v-text-field
                          v-model="editedItem.description"
                          ref="txtDescription"
                          dense
                          outlined
                          label="Description"
                        ></v-text-field>
                      </td>
                      <td width="15%">
                        <v-text-field
                          v-model="editedItem.unit"
                          ref="txtunit"
                          label="Qty"
                          type="number"
                          dense
                          outlined
                        ></v-text-field>
                      </td>
                      <td width="15%">
                        <v-text-field
                          v-model="editedItem.PricePerUnit"
                          ref="txtPricePerUnit"
                          label="Price per Unit"
                          type="number"
                          dense
                          outlined
                          @keydown.tab="save()"
                          @keydown.enter="save()"
                        ></v-text-field>
                      </td>
                      <td width="15%"></td>
                      <td width="8%"></td>
                    </tr>
                  </tbody>
                </v-simple-table> -->
              <div v-if="!sostatus" :style="{
                display: !sostatus ? 'show' : 'none',
              }" class="pl-2 pr-2 pt-2 elevation-1 heightsize55formadvance">
                <template>
                  <v-row>
                    <v-col cols="12" xl="1" lg="1" md="1" sm="1"></v-col>
                    <v-col cols="12" xl="4" lg="4" md="4" sm="4">
                      <v-text-field v-model="editedItem.description" ref="txtDescription" dense outlined
                        label="Description"></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                      <v-text-field v-model="editedItem.unit" ref="txtunit" label="Qty" type="number" min="0" dense
                        outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="2" lg="2" md="2" sm="2">
                      <v-text-field v-model="editedItem.PricePerUnit" ref="txtPricePerUnit" label="Price per Unit"
                        type="number" min="0" dense outlined @keydown.tab="save()"
                        @keydown.enter="save()"></v-text-field>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3"></v-col>
                  </v-row>
                </template>
              </div>
            </template>

            <br />
            <v-row class="heightsize55formadvance">
              <v-col class="text-right" cols="12" md="5"> </v-col>
              <v-col class="text-right" cols="12" md="4">Total </v-col>
              <v-col class="text-right" cols="12" md="3">
                <v-row>
                  <v-col cols="12" md="10">
                    <v-text-field reverse filled disabled outlined dense v-model="sumtotal"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="heightsize55formadvance">
              <v-col class="text-right" cols="12" md="5"> </v-col>
              <v-col class="text-right" cols="12" md="4">VAT ({{ vat }}%)
              </v-col>
              <v-col class="text-right" cols="12" md="3">
                <v-row>
                  <v-col cols="12" md="10">
                    <v-text-field reverse filled disabled outlined dense v-model="vatCal"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="heightsize55formadvance">
              <v-col class="text-right" cols="12" md="5"> </v-col>
              <v-col class="text-right" cols="12" md="4">Grand Total </v-col>
              <v-col class="text-right" cols="12" md="3">
                <v-row>
                  <v-col cols="12" md="10">
                    <v-text-field reverse filled disabled outlined dense v-model="sumGrandTotal"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <br />
            <hr />
            <br />
            <div :style="{ display: showbtnadd ? 'show' : 'none' }">
              <v-row>
                <v-col align="center" cols="12" md="12">
                  <v-btn :disabled="!sosubmitstatusbtn" class="mr-5 buttonblue" color="#689ADE"
                    @click="saveSOdraftstatus()">
                    Save Draft
                  </v-btn>
                  <v-btn depressed class="mr-5 buttonblue" :disabled="!sosubmitstatusbtn" @click="saveSOsubmit()">
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
              <div>
                <v-row v-if="sostatus" :style="{
                  display: sostatus ? 'show' : 'none',
                }">
                  <v-col align="end" cols="12" md="12">
                    <v-btn depressed class="buttonred" @click="dialogDeleteForm = true">
                      Delete form
                    </v-btn>
                  </v-col>
                </v-row>
              </div>

              <!-- <v-row>
                  <v-col align="end" cols="12" md="12">
                    <v-btn depressed class="buttonred">
                      Delete form
                    </v-btn>
                  </v-col>
                </v-row> -->
            </div>
          </v-card>

          <v-dialog v-model="dialogSendMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h6">Information Saved</v-card-title>
              <v-card-subtitle>
                บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="closeDeleteForm"
                    >Cancel</v-btn
                  > -->
                <v-btn color="blue darken-1" text @click="closeDialogSendmail()">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogSaveDraft" max-width="30%">
            <v-card>
              <v-card-title primary-title class="justify-center">
                {{ this.messageSaveDraft }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn color="blue darken-1" text @click="closeSaveDraft"
                                >Cancel</v-btn
                              > -->
                <v-btn color="blue darken-1" text @click="closeSaveDraft">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDeleteForm" max-width="400px">
            <v-card style="padding-top: 30px; padding-bottom: 30px;">
              <v-card-title style="padding-bottom: 20px;">
                <v-row justify="center">
                  <span class="red--text text-h5 ju">Delete this item?</span>
                </v-row>
              </v-card-title>
              <br />
              <v-card-subtitle>
                <v-row justify="center">
                  <span class="black--text">This action cannot be undone.</span>
                </v-row>
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed width="100" class="mr-3 buttonblue" color="red" @click="deleteItemConfirmForm">
                  Save
                </v-btn>
                <v-btn depressed outlined width="100" color="red" @click="closeDeleteForm">
                  Cancel
                </v-btn>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDeleteimage" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDeleteimage">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="removeimage">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
            <v-card>
              <v-card-title class="text-h5">
                <v-btn icon @click="closepreviewattachfile">
                  <v-icon large>mdi-close</v-icon>
                </v-btn>
                Preview PDF File</v-card-title>

              <!-- 
                                    :src="pdfdata"
                                    v-for="i in numPages"
                        :key="i"
                        :id="i"
                        :page="i" -->
              <div v-if="checkattachfileapreview" v-for="(item, index) in previewpopupattachfile2" :key="index">
                <pdf :src="item" v-for="i in numPagespreviewattach" :key="i" :id="i" :page="i">
                  <template slot="loading">
                    loading content here...
                  </template>
                </pdf>
              </div>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closepreviewattachfile">Cancel</v-btn>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
            <v-card>
              <v-card-title class="text-h5">
                <v-btn icon @click="closepreviewattachimage">
                  <v-icon large>mdi-close</v-icon>
                </v-btn>
                Preview Image</v-card-title>

              <v-img disabled :src="previewattachimage" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
              </v-img>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closepreviewattachimage">Cancel</v-btn>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="400px">
            <v-card style="padding-top: 30px; padding-bottom: 30px;">
              <v-card-title style="padding-bottom: 20px;">
                <v-row justify="center">
                  <span class="red--text text-h5 ju">Delete this item?</span>
                </v-row>
              </v-card-title>
              <br />
              <v-card-subtitle>
                <v-row justify="center">
                  <span class="black--text">This action cannot be undone.</span>
                </v-row>
              </v-card-subtitle>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed width="100" class="mr-3 buttonblue" color="red"
                  @click="deletedialogconfirmdeleteattachfile">
                  Save
                </v-btn>
                <v-btn depressed outlined width="100" color="red" @click="closedialogconfirmdeleteattachfile">
                  Cancel
                </v-btn>
                <!-- <v-btn
                  color="blue darken-1"
                  text
                  @click="closedialogconfirmdeleteattachfile"
                  >Cancel</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deletedialogconfirmdeleteattachfile"
                  >OK</v-btn
                > -->
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

          <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message"
            :link="link" />
        </v-container>
      </v-card-title>
    </v-row>
  </v-row>
</template>

<script>
import api from "@/services/api";
import {
  server,
  fileSaleorderUrl,
  imageSaleorderUrl,
} from "../services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { imageUrl } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "./computing/tolocalestringnumber";
import unity from "@/unity/unity";
import pdfvuer from "pdfvuer";

export default {
  name: "NewAdvance",
  data() {
    return {
      vat_type_list: [
        { id: "I", name: "Include Vat" },
        { id: "E", name: "Exclude Vat" },
      ],
      os_h: {
        customerid: 0,
        remark: "",
        contact_position: "",
        po_no: "",
        // po_date: "",
        // delivery_date: "",
        po_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        delivery_date: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000,
        )
          .toISOString()
          .substr(0, 10),
        additional: "",
        status: 0,
        image: "",
      },
      os_d: {
        sales_order_h_id: null,
        item_name: "",
        seq: 0,
        item_qty: 0,
        item_price: 0,
        item_line_amt: 0,
        user_update: localStorage.getItem(server.USER_ID),
      },
      preview_list: [],
      oldpreview_list: [],
      dialogDeleteimage: false,
      sumtotal: 0,
      vatCal: 0,
      sumGrandTotal: 0,
      vat: "",
      vat_type: "E",
      cus_id: 0,
      close_status: false,
      dialogDeleteForm: false,
      image_list: [],
      datecreate_at: "",
      saleorder_h_id: 0,
      saleorder_id: "",
      branch: "",
      customer_code: "",
      tax_id: "",
      currency: "",
      payment_term: "",
      invoice_address: "",
      customer_address: "",
      customer_list: [],
      customer_name: "",
      sosubmitstatusbtn: true,
      sostatus: false,
      showbtnadd: true,
      advance_code: [],
      advance_code_list: [],
      advance_code_id: 0,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      customer: [],
      customer_id: 0,
      options: {
        penColor: "#000000",
        backgroundColor: "rgb(255,255,255)",
      },
      initial_data2: "",
      initial_data: "",
      pickbank: false,
      pickcheque: false,
      checkcheque: false,
      checkchequefilled: false,
      showsig1: false,
      showsig2: false,
      showbuttonsavesig1: false,
      showbuttonsavesig2: false,
      defaultwordbuttonsig1: "Signature",
      defaultwordbuttonsig2: "Signature",
      totalleftoveramount: 0.0,
      sumwithdrawamount: 0.0,
      sunamountcleared: 0.0,
      showallamount: "",

      selectbankname: "",

      radioType: ["cash", "cheque"],
      radioGroup: "",
      setusername: localStorage.getItem(server.USERNAME),
      role: localStorage.getItem(server.ROLE),
      department: "DCM",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      search: "",
      selectedProductId: "",
      confirmDeleteDlg: false,
      mDataArray: [],
      // mDataArray: [{ id: "1", detail: "gg", amout: "1000" }],
      fullPage: true,
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: "No.",
          value: "no",
          class: "bg-colorth texttablehcenter ",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service/Description",
          value: "description",
          class: "bg-colorth texttablehcenter",
          width: "35%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "unit",
          class: "bg-colorth texttablehcenter ",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          text: "Price Per Unit",
          value: "PricePerUnit",
          class: "bg-colorth texttablehcenter",
          width: "17%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          class: "bg-colorth texttablehcenter",
          width: "17%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          width: "8%",
          divider: true,
          sortable: false,
        },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        code: "",
        description: "",
        amount: 0,
      },
      defaultItem: {
        code: "",
        description: "",
        amount: 0,
      },

      advance_log: {
        module: "SO",
        module_id: 0,
        approve_id: 0,
        approve_status: 0,
        approve_date: null,
      },
      lbl_date_request: false,
      dialogSignature: false,
      dialogSaveDraft: false,
      messageSaveDraft: "",
      paymentType: "",
      bankName: "",
      bankNumber: "",
      chequeNumber: "",
      sendMail: {
        name: "",
        email: "",
        advance_id: "",
        link: "",
      },
      account: {
        signature: "",
      },
      customerName: {},
      sostatus: false,
      customer_code: "",
      filenameattach: [],
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      dialogpreviewattachimage: false,
      dialogconfirmdeleteattachfile: false,
      numPagespreviewattach: 0,
      previewattachimage: "",
      indexdeleteattachfile: -1,
      getpreview_listattach: [],
      preview_listattach: [],
      image_listattach: [],
    };
  },
  components: {
    pdf: pdfvuer,
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    computedDatePOFormatted() {
      return unity.formatDate(this.os_h.po_date);
    },
    computedDateDeliveryFormatted() {
      return unity.formatDate(this.os_h.delivery_date);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    // this.$showLoader();

    await this.$forceUpdate();
    await this.loaddatadefault();
    await this.initialize();
    await this.loadCustomer();
    await this.loadAdvanceCode();

    const res_acc = await api.getAccountDetail(
      localStorage.getItem(server.USER_ID),
    );

    // console.log("res_acc : ", JSON.stringify(res_acc.data[0].signature));

    this.user_sign = res_acc.data[0].signature;

    this.showsig1 = true;
    this.dialogSignature = true;

    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    const result = await api.getAllCustomerListactiveCompany({
      params: {
        company_id: localStorage.getItem(server.COMPANYID),
      },
    });
    // console.log("result.data : ", JSON.stringify(result.data));
    this.customer = result.data;

    result.data.forEach((item) => {
      this.customer_list.push(item.name);
    });

    this.$hideLoader();
  },
  methods: {
    async getBackList() {
      this.$router.push(`/so-list`);
    },
    async previewattachfile(index) {
      const item = this.getpreview_listattach[index];
      if (!item) return;

      let url = item;

      if (url.startsWith('http')) {
        window.open(url, '_blank');
        return;
      }

      if (url.startsWith('data:')) {
        const file = this.image_listattach[index];

        if (!file) {
          console.error('ไม่พบไฟล์ใน image_listattach');
          return;
        }

        if (file instanceof Blob) {
          const blobUrl = URL.createObjectURL(file);
          window.open(blobUrl, '_blank');

          setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
          return;
        }

        window.open(url, '_blank');
        return;
      }

    },
    async getPforpreviewattach(datafile) {
      this.previewpopupattachfile = [];
      let getfile = "";
      getfile = datafile;
      this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupattachfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreviewattach = pdf.numPages;
        });
      });
    },
    async closepreviewattachfile() {
      this.dialogpreviewattachfile = false;
    },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async loaddatadefault() {
      this.main_id = this.$route.params.id;
      const res_h = await api.getAllSOById(this.main_id);
      console.log("res_h.data");
      console.log(res_h.data);
      if (res_h.data[0]) {
        let dataso_h = res_h.data[0];
        if (dataso_h.image) {
          this.filenameattach = dataso_h.image.split(",");
          this.filenameattach.forEach((x, index) => {
            if (x.split(/[\s.]+/).pop() == "pdf") {
              this.image_listattach.push(
                `${fileSaleorderUrl}/${this.$route.params.id}/${x}`,
              );
              this.getpreview_listattach.push(
                `${fileSaleorderUrl}/${this.$route.params.id}/${x}`,
              );
            } else {
              this.image_listattach.push(
                `${imageSaleorderUrl}/${this.$route.params.id}/${x}`,
              );
              this.getpreview_listattach.push(
                `${imageSaleorderUrl}/${this.$route.params.id}/${x}`,
              );
            }
          });
          // let setiamggfile = dataso_h.image.split(",");
          // setiamggfile.forEach((x) => {
          //   this.oldpreview_list.push(`${imageUrl}/${x}`);
          // });
        }
        if (dataso_h.status === "Draft") {
          this.sosubmitstatusbtn = true;
          this.sostatus = false;
        } else {
          this.sosubmitstatusbtn = false;
          this.sostatus = true;
        }
        this.saleorder_id = dataso_h.saleorder_id;
        this.datecreate_at = dataso_h.created_at;
        this.customer_id = dataso_h.customer_id;
        this.customer_name = dataso_h.name;
        this.customer_address = dataso_h.customer_address;
        this.invoice_address = dataso_h.customer_inv_address;
        this.payment_term = dataso_h.payment_term;
        this.currency = dataso_h.currency;
        this.vat = dataso_h.vat;
        this.vat_type = dataso_h.vat_type;
        this.vatCal = dataso_h.sum_tax;
        this.customer_code = dataso_h.customer_code;
        this.tax_id = dataso_h.tax_id;
        this.branch = dataso_h.branch;
        this.os_h.remark = dataso_h.remark;
        this.os_h.contact_position = dataso_h.contact_position;
        this.os_h.po_no = dataso_h.po_no;
        this.os_h.po_date = dataso_h.po_date;
        this.os_h.delivery_date = dataso_h.delivery_date;
        this.os_h.additional = dataso_h.additional;
        this.os_h.customerid = dataso_h.customer_id;
      }
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      const res_d = await api.getAlldetailSOById(this.main_id);
      console.log(
        `res_d getAlldetailSOById data : ${JSON.stringify(res_d.data)}`,
      );

      // this.desserts = res_d.data;

      // mapping field จาก DB (lowercase) → field ที่ calvatAll ใช้ (camelCase)
      this.desserts = res_d.data.map((item, index) => ({
        no: index + 1,
        description: item.description,
        unit: item.unit,
        PricePerUnit: item.priceperunit, // ← lowercase จาก DB → camelCase ที่ใช้ใน calvatAll
        amount: item.amount,
      }));

      this.calvatAll();
      loader.hide();
    },
    async save() {
      // alert("texttable")
      if (this.editedItem.description == "") {
        // alert("กรุณากรอก Description/Service ");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center",
        );
        this.$refs["txtDescription"].focus();
        return;
      }

      if (
        this.editedItem.unit == undefined ||
        this.editedItem.unit == "0" ||
        this.editedItem.unit == 0
      ) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center",
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (this.editedItem.unit < 0) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center",
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (
        this.editedItem.PricePerUnit == undefined ||
        this.editedItem.PricePerUnit == "0" ||
        this.editedItem.PricePerUnit == 0
      ) {
        // alert("กรุณากรอกจำนวนเงินต่อหน่วย");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center",
        );
        this.$refs["txtPricePerUnit"].focus();
        return;
      }

      if (this.editedItem.PricePerUnit < 0) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid data",
          "Please check your data and try again.",
          "text-h5 red--text text-center",
        );
        this.$refs["txtunit"].focus();
        return;
      }
      // if (this.editedItem.amount == 0 ) {
      //   alert("กรุณากรอกจำนวนเงิน");
      //   this.$refs["txtAmount"].focus();
      //   return;
      // }

      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      await this.calvatAll();

      this.close();
    },
    calvatAll(vat) {
      this.sumtotal = 0;
      this.sumGrandTotal = 0;
      this.vatCal = 0;

      console.log(`calvatAll data : ${JSON.stringify(this.desserts)}`);

      this.desserts.forEach((item, index) => {
        item.no = index + 1;

        // ✅ เพิ่มการตรวจสอบก่อนแปลงค่า
        const unitStr =
          item.unit != null && item.unit !== "" ? item.unit.toString() : "0";
        const priceStr =
          item.PricePerUnit != null && item.PricePerUnit !== ""
            ? item.PricePerUnit.toString()
            : "0";

        item.unit = stringcommatonumber(unitStr);
        item.PricePerUnit = stringcommatonumber(priceStr);
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);

        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });

      // ✅ ตรวจสอบค่า vat ก่อนคำนวณ
      const vatValue = parseFloat(this.vat) || 0;

      if (this.vat_type == "E") {
        this.sumtotal = this.sumtotal.toFixed(2);
        this.vatCal = (this.sumtotal * (vatValue / 100)).toFixed(2);
        this.sumGrandTotal = (this.sumtotal * (1 + vatValue / 100)).toFixed(2);
      } else if (this.vat_type == "I") {
        this.sumGrandTotal = this.sumtotal.toFixed(2);
        this.sumtotal = (this.sumGrandTotal / (1 + vatValue / 100)).toFixed(2);
        this.vatCal = (this.sumGrandTotal - this.sumtotal).toFixed(2);
      }

      this.vatCal = tolocalestringnumber(this.vatCal);
      this.sumtotal = tolocalestringnumber(this.sumtotal);
      this.sumGrandTotal = tolocalestringnumber(this.sumGrandTotal);
    },

    closeDialogSendmail() {
      this.dialogSendMail = false;
      this.$router.push("/advance-list");
    },
    async loadAdvanceCode() {
      // console.log("loadAdvanceCode");

      let company_id = localStorage.getItem(server.COMPANYID);

      // console.log("loadAdvanceCode company_id:" + company_id);

      const result = await api.getAllAdvanceCodeByCompany(company_id);

      // console.log("loadAdvanceCode : ", JSON.stringify(result.data));
      this.advance_code = result.data;

      result.data.forEach((item) => {
        this.advance_code_list.push(item.code + " " + item.description);
      });
    },
    onSelectAdvanceCodeChange(acvance_code) {
      // var tmp = null;
      // tmp = this.customer.filter((c) => c.name.includes(search_customer));

      // this.customer_id = tmp[0].id;
      // console.log("acvance_code : " + acvance_code);
      var tmp = acvance_code.split(" ");
      this.editedItem.code = tmp[0];
      this.editedItem.description = tmp[1];
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },

    changeFocusText(t) {
      // alert(t);
      if (t === 1) {
        this.$refs["txtCode"].focus();
      } else if (t === 2) {
        this.$refs["txtDescription"].focus();
      } else if (t === 3) {
        this.$refs["txtAmount"].focus();
        this.$refs["txtunit"].focus();
        this.$refs["txtPricePerUnit"].focus();
        // if (this.editedItem.code == "") {
        //   alert("กรุณากรอกรหัสการขออนุมัติ");
        //   this.$refs["txtCode"].focus();
        // } else {
        //   this.$refs["txtAmount"].focus();
        // }
      }
    },
    initialize() {
      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        this.sumwithdrawamount += item.amount;
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async loadCustomer() {
      // console.log("loadCustomer");
      let result = [];
      if (this.sosubmitstatusbtn === true) {
        result = await api.getAllCustomerListactiveCompany({
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
          },
        });
      } else {
        result = await api.getAllCustomerListCompany({
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
          },
        });
      }

      // console.log("result.data : ", JSON.stringify(result.data));
      this.customer = result.data;
      this.customer.forEach((item) => {
        item.address = `${item.address} ${item.provice} ${item.country} ${item.zipcode}`;
        item.invoice_address = `${item.address_invoice} ${item.province_invoice} ${item.country_invoice} ${item.zipcode_invoice}`;
      });
      // console.log("this.customer55")
      // console.log(this.customer)

      result.data.forEach((item) => {
        this.customer_list.push(item.name);
      });

      //   console.log("this customer:" + JSON.stringify(this.customer));

      //   console.log("this customer:" + this.advance_h.customer_id);
      //   var tmp = null;
      //   tmp = this.customer.filter((c) =>
      //     c.id.includes(1)
      //   );

      let cs_id = parseInt(this.customer_id, 10);

      let fill_cus = this.customer.filter(function (c) {
        return c.id == cs_id;
      });
      //   console.log("this customer:" + fill_cus);
      //   console.log("this customer:" + JSON.stringify(fill_cus));
      this.customer_name = fill_cus[0].name;
    },
    closeDelete() {
      this.calvatAll();

      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDeleteForm() {
      // alert("closeDeleteForm");
      this.dialogDeleteForm = false;
      this.close_status = true;
      this.closeStatus();
    },
    closeStatus() {
      this.dialogDeleteForm = false;
    },
    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirmForm() {
      // alert("deleteItemConfirmForm");
      this.deleteForm();
      this.closeDeleteForm();
    },
    async deleteForm() {
      // alert("deleteForm");
      this.close_status = false;
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      this.dialogDeleteForm = true;

      await api.deleteSOById(this.$route.params.id);
      await api.deletedetailSOById(this.$route.params.id);
      this.$store.state.global_push_dialog = true;
      this.setupAlertDialogPush(
        true,
        "Information Saved",
        "Your information has been deleted sales order",
        "text-h5 green--text text-center",
        "/so-list",
      );

      loader.hide();
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewMultiImage: function (event) {
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            // this.preview_list.push(e.target.result);
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listattach.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      console.log(this.image_list);
      this.image_listattach.forEach((x) => {
        if (x.name) {
          this.filenameattach.push(x.name);
        } else {
          this.filenameattach.push(x.split(/[\s/]+/).pop());
        }
      });
    },
    reset: function () {
      this.image = null;
      this.preview = null;
      this.image_list = [];
      this.preview_list = [];
      this.oldpreview_list = [];
    },
    closeSaveDraft() { },

    clickremoveimage(index) {
      this.indeximage = index;
      this.dialogDeleteimage = true;
    },
    async removeimage(index) {
      this.preview_list.splice(this.indeximage, 1);
      this.image_list.splice(this.indeximage, 1);

      this.dialogDeleteimage = false;
    },
    closeDeleteimage() {
      this.indeximage = null;
      this.dialogDeleteimage = false;
    },
    onSelectCustomerCodeChange(code) {
      if (!code) return;
      var tmp = null;
      tmp = this.customer.filter((c) => c.cust_account.includes(code));
      console.log(tmp);
      this.customer_id = tmp[0].id;
      this.customer_name = tmp[0].name;
      this.customer_address = tmp[0].address;
      this.invoice_address = tmp[0].address_invoice;
      this.payment_term = tmp[0].payment_term;
      this.currency = tmp[0].currency;
      this.customer_code = tmp[0].cust_account;
      this.branch = tmp[0].branch;
      this.tax_id = tmp[0].taxid;
      this.vat = tmp[0].vat;
      this.vat_type = tmp[0].vat_type;
      this.vatCal = tmp[0].vat;
      this.os_h.customerid = this.customer_id;
      this.os_h.remark = tmp[0].contact_name;
      this.os_h.contact_position = tmp[0].contact_position;
      console.log(this.customer_address);
      this.calvatAll();
    },
    onSelectCustomerChange(search_customer) {
      if (!search_customer) return;
      var tmp = null;
      tmp = this.customer.filter((c) => c.name.includes(search_customer));
      console.log(tmp);
      this.customer_id = tmp[0].id;
      this.customer_address = tmp[0].address;
      this.invoice_address = tmp[0].address_invoice;
      this.payment_term = tmp[0].payment_term;
      this.currency = tmp[0].currency;
      this.customer_code = tmp[0].cust_account;
      this.branch = tmp[0].branch;
      this.tax_id = tmp[0].taxid;
      this.vat = tmp[0].vat;
      this.vat_type = tmp[0].vat_type;
      this.vatCal = tmp[0].vat;
      this.os_h.customerid = this.customer_id;
      this.os_h.remark = tmp[0].contact_name;
      this.os_h.contact_position = tmp[0].contact_position;
      this.calvatAll();
    },
    async saveSOdraftstatus() {
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      this.advance_log.module_id = this.$route.params.id;
      this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
      this.advance_log.approve_status = 1;
      this.advance_log.approve_date = new Date();

      let formData = new FormData();
      this.image_listattach.forEach((x, index) => {
        formData.append(`file`, x);
      });

      if (this.image_listattach.length > 0) {
        let getnamefilenameattach = "";
        this.filenameattach.forEach((x, index) => {
          if (index > 0) {
            getnamefilenameattach += `,${x}`;
          } else {
            getnamefilenameattach += `${x}`;
          }
        });
        formData.append(
          `attachment_files`,
          getnamefilenameattach.replace(/\s/g, "_"),
        );
      } else {
        formData.append(`attachment_files`, "");
      }
      formData.append("customerid", this.customer_id);
      formData.append("customer_inv_address", this.invoice_address);
      formData.append("company_id", localStorage.getItem(server.COMPANYID));
      formData.append("customer_address", this.customer_address);
      formData.append("payment_term", this.payment_term);
      formData.append("currency", this.currency);
      formData.append("vat", stringcommatonumber(this.vat.toString()));
      formData.append("vat_type", this.vat_type);
      formData.append(
        "sum_disc",
        stringcommatonumber(this.sumtotal.toString()),
      );
      formData.append("sum_tax", stringcommatonumber(this.vatCal.toString()));
      formData.append(
        "sum_line_amt",
        stringcommatonumber(this.sumGrandTotal.toString()),
      );
      formData.append("remark", this.os_h.remark);
      formData.append("contact_position", this.os_h.contact_position);
      formData.append("po_no", this.os_h.po_no);
      formData.append("po_date", this.os_h.po_date);
      formData.append("delivery_date", this.os_h.delivery_date);
      formData.append("additional", this.os_h.additional);
      formData.append("status", 1);
      const updateso_h = await api.UpdateSO_H(this.main_id, formData);
      if (updateso_h.status == 200 || updateso_h.status == 201) {
        await api.deletedetailSOById(this.$route.params.id);
        if (this.desserts.length > 0) {
          this.desserts.forEach((item) => {
            // this.advance_d.advance_hid = res_h.data.id;
            this.os_d.sales_order_h_id = this.$route.params.id;
            this.os_d.seq = item.no;
            this.os_d.item_name = item.description;
            this.os_d.item_qty = stringcommatonumber(item.unit.toString());
            this.os_d.item_price = stringcommatonumber(
              item.PricePerUnit.toString(),
            );
            this.os_d.item_line_amt = stringcommatonumber(
              item.amount.toString(),
            );
            console.log(this.os_d);
            api.addDetailSO(this.os_d);
          });
        }

        this.sendMail.name = localStorage.getItem(server.FULLNAME);
        this.sendMail.email = localStorage.getItem(server.APPROVE_LEVEL1_EMAIL);
        this.sendMail.advance_id = this.$route.params.id;
        console.log("send_request1 : " + JSON.stringify(this.sendMail));
        const send_request = await api.sendMail(this.sendMail);

        console.log("send_request2 : " + JSON.stringify(send_request));
        if (send_request.status == 200) {
          // this.$store.state.global_dialog = true;

          // this.setupAlertDialogPush(
          //   true,
          //   "Information Saved",
          //   "บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ",
          //   "text-h5 green--text text-center",
          //   "/advance-list"
          // );

          const res_log = await api.addAdvanceLog(this.advance_log);
          // console.log("res_log : " + JSON.stringify(res_log.status));

          if (res_log.status == 201) {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "Information Saved",
              "Your information has been saved in draft.",
              "text-h5 green--text text-center",
              "/so-list",
            );
          } else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "ไม่สามารถบันทึกได้",
              "text-h5 red--text text-center",
            );
          }
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center",
        );
      }
      loader.hide();
    },
    async saveSOsubmit() {
      if (this.desserts.length <= 0) {
        // alert("กรุณาเลือกลูกค้า");
        // this.messageSaveDraft = "กรุณากรอกรายละเอียด Advance Detail";
        // this.dialogSaveDraft = true;
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด SO Detail",
          "text-h5 red--text text-center",
        );
        return;
      }

      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });

      this.advance_log.module_id = this.$route.params.id;
      this.advance_log.approve_id = localStorage.getItem(server.USER_ID);
      this.advance_log.approve_status = 2;
      this.advance_log.approve_date = new Date();

      let formData = new FormData();
      this.image_listattach.forEach((x, index) => {
        formData.append(`file`, x);
      });

      if (this.image_listattach.length > 0) {
        let getnamefilenameattach = "";
        this.filenameattach.forEach((x, index) => {
          if (index > 0) {
            getnamefilenameattach += `,${x}`;
          } else {
            getnamefilenameattach += `${x}`;
          }
        });
        formData.append(
          `attachment_files`,
          getnamefilenameattach.replace(/\s/g, "_"),
        );
      } else {
        formData.append(`attachment_files`, "");
      }

      formData.append("customerid", this.customer_id);
      formData.append("customer_inv_address", this.invoice_address);
      formData.append("company_id", localStorage.getItem(server.COMPANYID));
      formData.append("customer_address", this.customer_address);
      formData.append("payment_term", this.payment_term);
      formData.append("currency", this.currency);
      formData.append("vat", stringcommatonumber(this.vat.toString()));
      formData.append("vat_type", this.vat_type);
      formData.append(
        "sum_disc",
        stringcommatonumber(this.sumtotal.toString()),
      );
      formData.append("sum_tax", stringcommatonumber(this.vatCal.toString()));
      formData.append(
        "sum_line_amt",
        stringcommatonumber(this.sumGrandTotal.toString()),
      );
      formData.append("remark", this.os_h.remark);
      formData.append("contact_position", this.os_h.contact_position);
      formData.append("po_no", this.os_h.po_no);
      formData.append("po_date", this.os_h.po_date);
      formData.append("delivery_date", this.os_h.delivery_date);
      formData.append("additional", this.os_h.additional);
      formData.append("status", 2);
      const updateso_h = await api.UpdateSO_H(this.main_id, formData);
      if (updateso_h.status == 200 || updateso_h.status == 201) {
        await api.deletedetailSOById(this.$route.params.id);
        if (this.desserts.length > 0) {
          this.desserts.forEach((item) => {
            // this.advance_d.advance_hid = res_h.data.id;
            this.os_d.sales_order_h_id = this.$route.params.id;
            this.os_d.seq = item.no;
            this.os_d.item_name = item.description;
            this.os_d.item_qty = stringcommatonumber(item.unit.toString());
            this.os_d.item_price = stringcommatonumber(
              item.PricePerUnit.toString(),
            );
            this.os_d.item_line_amt = stringcommatonumber(
              item.amount.toString(),
            );
            console.log(this.os_d);
            api.addDetailSO(this.os_d);
          });

          this.sendMail.name = localStorage.getItem(server.FULLNAME);
          this.sendMail.email = localStorage.getItem(
            server.APPROVE_LEVEL1_EMAIL,
          );
          this.sendMail.advance_id = this.$route.params.id;
          console.log("send_request1 : " + JSON.stringify(this.sendMail));
          const send_request = await api.sendMail(this.sendMail);

          console.log("send_request2 : " + JSON.stringify(send_request));
          if (send_request.status == 200) {
            // this.$store.state.global_dialog = true;

            // this.setupAlertDialogPush(
            //   true,
            //   "Information Saved",
            //   "บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ",
            //   "text-h5 green--text text-center",
            //   "/advance-list"
            // );

            const res_log = await api.addAdvanceLog(this.advance_log);
            // console.log("res_log : " + JSON.stringify(res_log.status));

            if (res_log.status == 201) {
              this.$store.state.global_push_dialog = true;
              this.setupAlertDialogPush(
                true,
                "Submitted",
                "Information submit and sent to Approver.",
                "text-h5 green--text text-center",
                "/so-list",
              );
            } else {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Information Saved",
                "ไม่สามารถบันทึกได้",
                "text-h5 red--text text-center",
              );
            }
          }
        }
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center",
        );
      }
      loader.hide();
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  width: 120px;
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  min-height: 10px;
}

.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.widthsize80formadvance {
  width: 80%;
}

.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize70formadvance {
  height: 70px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}

.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}

.btnuploadfile {
  border: 2px solid;
}
</style>
